// eslint-disable-next-line require-jsdoc
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import IndeterminateShort from '@ids/indeterminate-short';
import { AddToCartPricingSection } from './PricingSections';
import { getImageSrc, isProductOutOfStock } from '../Util/CommonUtils';
// eslint-disable-next-line require-jsdoc
export const OftenBoughtTogetherPage = (props) => {
  const { pageData, loading, outOfStockItems = [] } = props;
  const product = pageData.Department.BroughtTogether;
  const [outOfStockPfid, setOutOfStockPfid] = useState({});

  useEffect(() => {
      const outOfStatusForPfid = isProductOutOfStock(
        {
          pfid: product.Department.PFID,
          sku: null,
        },
        outOfStockItems,
      );
      setOutOfStockPfid(outOfStatusForPfid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outOfStockItems]);

  return (
    <div className="margin-top-60">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-lg-12">
          <div className="margin-bottom-10" style={{ paddingBottom: '10px' }}>
            <h2>Often bought together</h2>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-3 col-lg-3">
          <div className="image-column">
            <img
              className="margin-bottom-20"
              alt="..."
              src={getImageSrc(product.Department.Image)}
            />
          </div>
        </div>
        <div className="col-xs-12 col-sm-6 col-lg-6">
          <div className="middle-content">
            <h4 className="margin-bottom-20">{product.Department.Name}</h4>
            {product.Department.Desc && (
              <p className="p2-regular margin-bottom-20">{product.Department.Desc}</p>
            )}
          </div>
        </div>
        <div className="col-xs-12 col-sm-3 col-lg-3">
          {loading ? (
            <div style={{ textAlign: 'center' }}>
              <IndeterminateShort theme="quickbooks" />
            </div>
          ) : outOfStockPfid?.displayOutOfStock ? (
            <div className="product-unavailable-msg margin-bottom-20">
              {outOfStockPfid.outOfStockMessage}
            </div>
          ) : (
            !outOfStockPfid?.displayOutOfStock && (
              <AddToCartPricingSection {...props} pageData={product} />
            )
          )}
        </div>
      </div>
    </div>
  );
};

OftenBoughtTogetherPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  pageData: PropTypes.object.isRequired,
};
